"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    if (i % 2) {
      var source = arguments[i] != null ? arguments[i] : {};
      var ownKeys = Object.keys(source);

      if (typeof Object.getOwnPropertySymbols === 'function') {
        ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
          return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
      }

      ownKeys.forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i]));
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getAssetPreviewProps(_ref) {
  var asset = _ref.asset,
      width = _ref.width,
      height = _ref.height;
  var loadedPercent = asset.loadedPercent,
      assetId = asset.assetId,
      ORIGINAL = asset.assetFiles.ORIGINAL;
  return _objectSpread({
    width: width,
    height: height
  }, loadedPercent !== void 0 || !ORIGINAL || ORIGINAL.status === 'IN_PROGRESS' ? {
    assetId: assetId
  } : {
    asset: asset
  });
}

var _default = getAssetPreviewProps;
exports.default = _default;